/*
 * Copyright (C) 2019 - present by OpenGamma Inc. and the OpenGamma group of companies
 *
 * Please see distribution for license.
 */
import { Component, Input, EventEmitter, Output } from '@angular/core';
import { Theme, Size, NamedValue } from 'app/shared/models';
import { MatSelectionListChange } from '@angular/material/list';
import { CommittableData } from 'app/page-modules/tenant-management/store/models';

@Component({
  selector: 'og-selection-list',
  templateUrl: './selection-list.component.html',
  styleUrls: ['./selection-list.component.scss'],
  standalone: false
})
export class SelectionListComponent {
  /** The list of allowed values */
  @Input() allowedValues: NamedValue<string>[];
  /** The list of entries to display */
  @Input() list: CommittableData<string[]>;
  /** Defines if the list entries are being loaded */
  @Input() isLoading: boolean;
  /** Defines if the details are editable */
  @Input() isEditable: boolean;
  /** Defines the custom theme to be used */
  @Input() theme: Theme = 'accent';
  /** Defines the custom size to be used */
  @Input() size: Size = 'medium';
  /** Emits list changes */
  @Output() listChange = new EventEmitter<string[]>();

  filterUnexpectedValues(): string[] {
    const allowed = this.allowedValues.map(item => item.value);
    return this.list.original.filter(item => !allowed.includes(item));
  }

  onSelectionListChange($event: MatSelectionListChange): void {
    const selectedOptions = $event.source.selectedOptions.selected.map(option => option.value);
    this.listChange.next(selectedOptions);
  }
}
